import { CurrentInternalUserQuery, useCurrentInternalUserQuery } from "src/queries/user.generated";

export function useCurrentUser(): NonNullable<CurrentInternalUserQuery["currentInternalUser"]> {
  const { data } = useCurrentInternalUserQuery({ fetchPolicy: "cache-first" });
  return data?.currentInternalUser! || {};
}
